import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper, InputText } from '@dixa/lib-shared-habla';
import { useCopy } from 'utils/useCopy';
export const TokenFieldTemplate = ({ value, label, }) => {
    const [copyToClipboard, copyState] = useCopy();
    return (_jsx(FieldWrapper, Object.assign({ label: label }, { children: _jsx(InputText, { readOnly: true, value: value, suffix: {
                type: 'button',
                button: {
                    icon: copyState.status === 'copied' ? 'done' : 'copy',
                    onClick: () => copyToClipboard(value),
                },
            } }) })));
};
